import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Modal from '~/commons/components/Modal.jsx';

const ModalAnsConfirm = () => {
  const [show, setShow] = useState(false);
  const [content, setContent] = useState(null);
  const [, popReq] = useHttpStatus();
  const [, fetchReq] = useHttpStatus({
    onSuccess({ data: popup = {} }) {
      if (popup) {
        setContent(popup);
        setShow(true);
        popReq({
          url: `api/site/announcements/pop/${popup._id}`,
        });
      }
    },
  });

  useEffect(() => {
    fetchReq({
      url: 'api/site/announcements/popup',
    });
  }, []);

  return content ? (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      centered
      size="lg"
      className="p-0"
    >
      <Link
        to={`/app/announcements/${content._id}`}
        onClick={() => setShow(false)}
      >
        <img
          className="w-100"
          src={content.coverImg}
          alt={content.title}
        />
      </Link>
    </Modal>
  ) : '';
};

export default ModalAnsConfirm;
